import { useAppSelector } from "redux/hooks";
import DeleteDialog from "../Dialogs/DeleteList";
import DeleteSCList from "../Dialogs/DeleteSCList";
import EditScSavedList from "../Dialogs/EditList";
import RenameList from "../Dialogs/RenameList";

const ModalHandler = () => {
  const isEditListModal = useAppSelector((state) => state.CorpDashboard.isEditListModal);
  const isOpenSaved = useAppSelector((state) => state.CorpDashboard.dialogs.deleteList.isOpen);
  const isOpenSC = useAppSelector((state) => state.CorpDashboard.dialogs.deleteSCList.isOpen);
  const isOpenRename = useAppSelector((state) => state.CorpDashboard.dialogs.renameList.isOpen);

  return (
    <>
      {isOpenSaved && <DeleteDialog />}
      {isOpenSC && <DeleteSCList />}
      {isEditListModal && <EditScSavedList isEditListModal={isEditListModal} />}
      {isOpenRename && <RenameList />}
    </>
  );
};

export default ModalHandler;
